import { Button, Dialog, DialogActions, DialogTitle } from "@mui/material";

export interface ActionConfirmationDialogProps {
    isOpen: boolean;
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
    confirmationMessage: string;
    confirmedParentAction: () => void | Promise<void>;
    submitButtonName?: string | null;
    doAfterConfirmation?: () => void | Promise<void>;
}

export function ActionConfirmationDialog({
    isOpen,
    setIsOpen,
    confirmationMessage,
    confirmedParentAction,
    submitButtonName,
    doAfterConfirmation,
}: ActionConfirmationDialogProps) {
    const handleClose = (): void => {
        setIsOpen(false);
    };

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>): Promise<void> => {
        event.preventDefault();
        await confirmedParentAction();
        setIsOpen(false);
        
        if (doAfterConfirmation != null) {
            await doAfterConfirmation();
        }
    }
    
    return (
        <Dialog
            open={isOpen}
            onClose={() => setIsOpen(false)}
            PaperProps={{
                component: 'form',
                onSubmit: handleSubmit,
            }}
        >
            <DialogTitle>{confirmationMessage}</DialogTitle>
            <DialogActions>
                <Button
                    sx={{ fontWeight: "bold" }}
                    onClick={handleClose}
                >
                    Cancel
                </Button>
                <Button
                    size="small"
                    variant="contained"
                    color="primary"
                    type="submit"
                >
                    {submitButtonName != null
                        ? submitButtonName
                        : "Confirm"}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
